var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ak-form", {
    key: _vm.bundle + _vm.definition + _vm.objectId,
    attrs: {
      bundle: _vm.bundle,
      definition: _vm.definition,
      objectId: _vm.objectId,
      relationString: _vm.relationString,
    },
    on: { save: _vm.goToGrid },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }